(() => {
  const root = document.querySelector('[data-bek-order-status]');
  if (!root) return;

  const form = root.querySelector('[data-status-form]');
  const feedback = root.querySelector('[data-status-feedback]');
  const result = root.querySelector('[data-status-result]');
  const button = root.querySelector('[data-status-submit]');
  const endpoint = root.dataset.endpoint || '/apps/bek-order/order-status';

  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const text = (selector, value) => $$(selector).forEach((el) => { el.textContent = value ?? ''; });

  const PRODUCT_ICONS = {
    TDS: 'roof', SKYVIEW: 'roof', FLATLINE: 'car', TDS_CARPORT: 'car', SHADING: 'sun', SG23: 'glass', SUNPROPLUS: 'sun'
  };

  const ICON_SVGS = {
    roof: '<svg viewBox="0 0 24 24"><path d="M3 11 12 4l9 7"></path><path d="M5 10v9h14v-9"></path><path d="M8 19v-5h8v5"></path></svg>',
    car: '<svg viewBox="0 0 24 24"><path d="M4 16v-5l2-5h12l2 5v5"></path><path d="M5 11h14M7 16h10"></path><circle cx="7" cy="17" r="2"></circle><circle cx="17" cy="17" r="2"></circle></svg>',
    sun: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"></path></svg>',
    glass: '<svg viewBox="0 0 24 24"><path d="M4 3h16v18H4zM9 3v18M15 3v18"></path><path d="m6 8 2-2M11 10l2-2M17 8l1-1"></path></svg>'
  };

  function setFeedback(message, kind = 'info') {
    feedback.textContent = message || '';
    feedback.dataset.kind = kind;
  }

  function setLoading(loading) {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
    button.innerHTML = loading ? 'Status wird geladen …' : 'Status anzeigen <span aria-hidden="true">→</span>';
  }

  function clearResult() {
    result.hidden = true;
    text('[data-status-order]', '');
    text('[data-status-product]', '');
    text('[data-status-label]', '');
    text('[data-status-message]', '');
    $('[data-status-timeline]')?.replaceChildren();
    $('[data-status-history]')?.replaceChildren();
    $('[data-status-history-wrap]')?.setAttribute('hidden', '');
  }

  function dateValue(value, options = {}) {
    if (!value) return '–';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '–';
    return new Intl.DateTimeFormat('de-DE', options).format(date);
  }

  function dateOnly(value) {
    return dateValue(value, { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function dateTime(value) {
    return dateValue(value, { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  }

  function iconForProduct(code) {
    const name = PRODUCT_ICONS[String(code || '').toUpperCase()] || 'roof';
    return `<span class="bek-icon bek-icon--${name}" aria-hidden="true">${ICON_SVGS[name] || ICON_SVGS.roof}</span>`;
  }

  function latestHistoryDate(history, code) {
    if (!Array.isArray(history)) return '';
    for (let i = history.length - 1; i >= 0; i -= 1) {
      if (history[i]?.code === code && history[i]?.at) return history[i].at;
    }
    return '';
  }

  function renderTimeline(status) {
    const timeline = $('[data-status-timeline]');
    timeline.replaceChildren();
    const history = Array.isArray(status.history) ? status.history : [];
    (Array.isArray(status.timeline) ? status.timeline : []).forEach((step, index) => {
      const row = document.createElement('div');
      row.className = 'bek-order-step';
      row.dataset.state = step.state || 'pending';

      const rail = document.createElement('div');
      rail.className = 'bek-order-step__rail';
      const dot = document.createElement('div');
      dot.className = 'bek-order-step__dot';
      dot.innerHTML = step.state === 'complete' ? '<span>✓</span>' : step.state === 'current' ? '<span>●</span>' : `<span>${index + 1}</span>`;
      rail.append(dot);

      const body = document.createElement('div');
      body.className = 'bek-order-step__body';
      const label = document.createElement('strong');
      label.textContent = step.label || '';
      const meta = document.createElement('small');
      const at = latestHistoryDate(history, step.code);
      meta.textContent = at ? `${step.state === 'current' ? 'Seit' : 'Abgeschlossen am'} ${dateOnly(at)}` : (step.state === 'pending' ? 'Noch ausstehend' : '');
      body.append(label, meta);
      row.append(rail, body);
      timeline.append(row);
    });
  }

  function renderHistory(status) {
    const wrap = $('[data-status-history-wrap]');
    const list = $('[data-status-history]');
    list.replaceChildren();
    const history = Array.isArray(status.history) ? status.history : [];
    if (!history.length) {
      wrap.hidden = true;
      return;
    }
    history.slice().reverse().forEach((entry, index) => {
      const item = document.createElement('article');
      item.className = 'bek-order-history__item';
      if (index === 0) item.classList.add('is-latest');
      const date = document.createElement('time');
      date.dateTime = entry.at || '';
      date.textContent = dateTime(entry.at);
      const copy = document.createElement('div');
      const title = document.createElement('strong');
      title.textContent = entry.label || 'Statusänderung';
      const message = document.createElement('p');
      message.textContent = entry.message || '';
      copy.append(title, message);
      item.append(date, copy);
      list.append(item);
    });
    wrap.hidden = false;
  }

  function renderDelivery(delivery = {}) {
    const title = $('[data-status-delivery-title]');
    const note = $('[data-status-delivery-note]');
    const tracking = $('[data-status-tracking]');
    const date = String(delivery.date || '').trim();
    const windowText = String(delivery.window || '').trim();
    const deliveryNote = String(delivery.note || '').trim();
    const trackingNumber = String(delivery.trackingNumber || '').trim();
    const trackingUrl = String(delivery.trackingUrl || '').trim();

    if (date) {
      const parsed = /^\d{4}-\d{2}-\d{2}$/.test(date) ? `${date}T12:00:00` : date;
      const formatted = dateOnly(parsed);
      title.textContent = windowText ? `${formatted} · ${windowText}` : formatted;
      note.textContent = deliveryNote || 'Der Liefertermin wurde mit Ihnen abgestimmt.';
    } else if (windowText) {
      title.textContent = windowText;
      note.textContent = deliveryNote || 'Weitere Details zur Lieferung folgen nach Abstimmung.';
    } else {
      title.textContent = 'Termin noch offen';
      note.textContent = deliveryNote || 'Sobald ein Liefertermin abgestimmt ist, erscheint er hier.';
    }

    if (trackingUrl) {
      tracking.hidden = false;
      tracking.href = trackingUrl;
      tracking.textContent = trackingNumber ? `Sendung ${trackingNumber} verfolgen →` : 'Sendung verfolgen →';
    } else {
      tracking.hidden = true;
      tracking.removeAttribute('href');
    }
  }

  function render(data) {
    const status = data.status || {};
    const order = data.order || {};
    const productCode = String(order.productCode || '').toUpperCase();
    const orderName = data.orderName || order.name || '';
    const productName = order.productName || 'BEK Bestellung';

    text('[data-status-order]', `Bestellung ${orderName}`);
    text('[data-status-product]', productName);
    text('[data-status-label]', status.label || 'Bestellstatus');
    text('[data-status-message]', status.message || '');
    text('[data-status-order-date]', order.createdAt ? `Bestellt am ${dateOnly(order.createdAt)}` : 'Bestelldatum –');
    text('[data-status-updated]', status.updatedAt ? `Aktualisiert ${dateTime(status.updatedAt)}` : 'Aktualisiert –');

    text('[data-status-fact-order]', orderName || '–');
    text('[data-status-fact-product]', productName);
    text('[data-status-fact-date]', dateOnly(order.createdAt));
    text('[data-status-fact-updated]', dateTime(status.updatedAt));

    const icon = $('[data-status-product-icon]');
    if (icon) icon.innerHTML = iconForProduct(productCode);
    const pill = $('.bek-order-dashboard__status-pill');
    if (pill) pill.dataset.statusCode = status.code || '';

    renderTimeline(status);
    renderHistory(status);
    renderDelivery(data.delivery || {});
    result.hidden = false;
    requestAnimationFrame(() => result.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearResult();
    setFeedback('Ihre Bestellung wird sicher zugeordnet …', 'info');
    setLoading(true);

    const payload = {
      order: form.elements.order.value,
      email: form.elements.email.value,
      zip: form.elements.zip.value
    };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) {
        throw new Error(data.message || 'Die Angaben konnten keiner BEK-Bestellung zugeordnet werden.');
      }
      setFeedback('', 'info');
      render(data);
    } catch (error) {
      setFeedback(error.message || 'Der Bestellstatus konnte gerade nicht geladen werden.', 'error');
    } finally {
      setLoading(false);
    }
  });
})();
